exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".deckEditor{background:transparent}.deckEditor .deckSelector{width:100%;font-size:1.25em}.deckEditor .options{padding:.5em 0 0 .5em}.deckEditor .options .buttonRow{display:flex;justify-content:space-around;margin-bottom:.5em}.deckEditor .options .buttonRow>*{flex-grow:1}.deckEditor .options .buttonRow>:not(:first-child){margin-left:1px}.deckEditor .options .buttonRow>:last-child{margin-left:200px}.importDeck textarea{width:100%;height:280px}.importDeck button{float:right}.modal{box-sizing:border-box;position:absolute;background-color:rgba(70,63,63,.9);left:7%;top:6%;width:84%;height:375px}.modal .modalContent{padding:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1db24b35","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DeckEditor.vue
// module id = 42
// module chunks = 0